
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'ionic-cache';
import { API } from './api';
import { DataService } from './data.service';
import { FeatureFlags } from './featureFlags';
import { LocalStorageService } from './localStorage.service';

@Injectable()
export class Settings {
  constructor(
    private readonly data: DataService,
    private readonly localStorage: LocalStorageService,
    private readonly translate: TranslateService,
    private readonly ftFlags: FeatureFlags,
    private readonly cache: CacheService,
    private readonly api: API,
  ) {
  }

  public loadSettings(view, login, splash?) {
    this.api.loadConfig().then(appConf => {
      // set from api
      this.loadSettingsHandler(appConf, view, login, splash);

      if (appConf.data.settings.cache_ttl) { // set the default cache TTL
        this.cache.setDefaultTTL(appConf.data.settings.cache_ttl);
      }
    }).catch(error => {
      this.api.loadConfigMock().then(appConf => {
        // set from mock if no api settings. TODO: decidir si queremos cargar un mock o no.
        this.loadSettingsHandler(appConf, view, login, splash);
      }).catch(error => {
        view.setRoot('TabsPage', { login }).then(response => {
          if (splash && splash != null) splash.dismiss();
        });
      });
    });
  }

  private loadSettingsHandler(appConf: any, view, login, splash?) {
    this.localStorage.setAppConf(appConf.data.settings).then((result) => {
      this.data.insertCustomCSS(result);
      this.setRootPageModule(result, view, login, (splash) ? splash : null);
    });
  }

  private getRootPageName(settings) {
    let pageAux = 'TabsPage';
    if (!this.ftFlags.DiningRooms &&
      settings.show_news === 0 &&
      settings.show_events === 0 &&
      settings.show_courses === 0 &&
      settings.show_advantages === 0 &&
      settings.show_directory === 0) {

      pageAux = 'MyOfficePage';
    }
    return pageAux;
  }

  private setRootPageModule(settings, view, login, splash?) { // TODO: revisar
    if (!this.ftFlags.DiningRooms) {
      const tabs = this.setConfigShowTabs(settings);
      let showFirst = false;

      tabs.map((tabs, index) => {
        if (tabs.show && !showFirst) {
          showFirst = true;
        }
      });
    }

    const pageName = this.getRootPageName(settings);
    view.setRoot(pageName, { login }).then(response => {
      if (splash && splash != null) splash.dismiss();
    });
  }

  private setConfigShowTabs(appConf) {
    const configTabs: any = [{ root: 'HomePage', name: this.translate.instant('Tabs.inicio'), icon: 'tab-inicio', id: 'show_home', show: true },
    { root: 'TrainingPage', name: this.translate.instant('Tabs.formacion'), icon: 'tab-formacion', id: 'show_courses', show: true },
    { root: 'AdvantagesPage', name: this.translate.instant('Tabs.advantages'), icon: 'tab-ventajas', id: 'show_advantages', show: true },
    { root: 'CompanyPage', name: 'Fuifi', icon: 'company', id: 'show_directory', show: true },
    { root: 'MyOfficePage', name: this.translate.instant('Office.my'), icon: 'tab-office', id: 'show_office', show: true }];

    configTabs.map(tabs => {
      if (appConf[tabs.id] === 0) {
        tabs.show = false;
      } else {
        tabs.show = true;
        if (tabs.root === 'CompanyPage') {
          tabs.name = appConf.company_name;
        }
        if (appConf[tabs.id] === 'show_news') {
          configTabs[0].name = this.translate.instant('Home.noticias');
        } else if (appConf[tabs.id] === 'show_events') {
          configTabs[0].name = this.translate.instant('Home.eventos');
        }
      }
    });

    if (appConf.show_news === 0 && appConf.show_events === 0) {
      configTabs[0].show = false;
    }
    return configTabs;
  }
}



// WEBPACK FOOTER //
// ./src/services/settings.service.ts